import { Dispatch } from 'redux'

import * as Api from 'redux/api/Surveys'

import { TPostNPSBody, TShowNPS } from 'types/GlobalNPS'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as npsActions from '../NPS/actions'

const HIDE_NPS: TShowNPS = { show: false, refetch: false }

function tryCreateSurvey(body: TPostNPSBody, cb?: () => void) {
  return (dispatch: Dispatch) => {
    Api.create(body)
      .then(() => {
        dispatch(npsActions.setShowNps(HIDE_NPS))

        cb?.()
      })
      .catch(() => {
        dispatch(npsActions.setShowNps(HIDE_NPS))

        cb?.()
      })
  }
}

function tryGetShowNps() {
  return (dispatch: Dispatch) => {
    Api.getShowNps()
      .then((response) => {
        dispatch(npsActions.setShowNps(response.data.data))
      })
      .catch(() => {
        dispatch(npsActions.setShowNps(HIDE_NPS))
      })
  }
}

export const useSurveyActions = () => {
  return {
    tryCreateSurvey: useThunkActions(tryCreateSurvey),
    tryGetShowNps: useThunkActions(tryGetShowNps)
  }
}
